// extracted by mini-css-extract-plugin
export var container = "_eh-0";
export var icon = "_eh-1";
export var text = "_eh-2";